import { Component } from 'react';
import { ConnectedProps, connect } from 'react-redux';

import { ApiInvite } from 'api/invite/types/ApiInvite';
import { ApiUserLocation } from 'api/types/ApiUserLocation';
import { signUp } from 'api/userEnvironment/apiUserEnvironment';
import { FormUsageContext } from 'components/Form/Form';
import { SignupForm } from 'components/SignupForm';
import { MainStoreState } from 'store/MainStoreState';
import { updateUserEnvironment } from 'store/ducks/userEnvironment.actions';
import { fetchUserLocation } from 'store/ducks/userLocation.actions';
import { trackSignUp } from 'utils/analytics/track/trackSignUp';
import { configureTrackJs } from 'utils/configureTrackJs';
import { deleteCookie } from 'utils/cookies';
import { getThirdPartyLoginUrl } from 'utils/getThirdPartyLoginUrl';
import {
  searchLocationToUserLocation,
  userLocationToSearchLocation,
} from 'utils/location';
import { resetRecaptcha } from 'utils/recaptcha';
import { pushFlashMessage } from 'zustand-stores/flashMessagesStore';
import { showModal } from 'zustand-stores/modalStore';

type OwnProps = {
  analyticsTitle: string;
  usageContext: FormUsageContext;
  redirectTo?: string | null | undefined;
  firstName?: string;
  lastName?: string;
  email?: string;
  savedListing?: { id: string; type: string; name: string };
  subscribedSubsite?: string | null | undefined;
  invite?: ApiInvite | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSignup: ((...args: Array<any>) => any) | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onLogin: ((...args: Array<any>) => any) | null | undefined;
  uncloseable?: boolean;
};

type Props = OwnProps & PropsFromRedux;

class UnconnectedSignupFormContainer extends Component<Props> {
  componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (!this.props.userLocation) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.fetchUserLocation();
    }
  }

  get initialValues() {
    return {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      firstName: this.props.firstName || '',
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      lastName: this.props.lastName || '',
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-nested-ternary, react/destructuring-assignment
      email: this.props.invite
        ? // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          this.props.invite.email
        : // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          this.props.email // TODO: Fix this the next time the file is edited.
          ? // eslint-disable-next-line react/destructuring-assignment
            this.props.email
          : '',
      password: '',
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      location: userLocationToSearchLocation(this.props.userLocation),
      gRecaptchaResponse: undefined,
    };
  }

  showLoginModal = (email: string) => {
    const {
      savedListing,
      redirectTo,
      subscribedSubsite,
      onLogin,
      uncloseable,
    } = this.props;

    showModal('LOGIN', {
      redirectTo,
      savedListing,
      subscribedSubsite,
      email,
      // @ts-expect-error TS(2322): Type '((...args: any[]) => any) | null | undefined... Remove this comment to see the full error message
      onLogin,
      uncloseable,
    });
  };

  getLoginUrlAndState = (email: string) => {
    const { redirectTo, invite, savedListing, subscribedSubsite } = this.props;
    return {
      to: '/login',
      state: {
        redirectTo,
        email,
        inviteId: invite?.id,
        savedListing,
        subscribedSubsite,
      },
    };
  };

  getThirdPartyLoginUrl = (provider: 'facebook' | 'google' | 'apple') => {
    const { redirectTo, invite, savedListing, subscribedSubsite } = this.props;
    return getThirdPartyLoginUrl({
      provider,
      redirectTo,
      inviteId: invite?.id,
      savedListing,
      subscribedSubsite,
    });
  };

  onSubmit = ({
    values,
    handleError,
  }: {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    values: Record<string, any>;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleError: (...args: Array<any>) => any;
  }) => {
    deleteCookie('userDismissedNotificationPreferencesDialog');
    const {
      firstName,
      lastName,
      email,
      password,
      location,
      recaptchaKey,
      gRecaptchaResponse,
    } = values;
    const signupInfo = {
      firstName,
      lastName,
      email,
      password,
      gRecaptchaResponse,
      ...searchLocationToUserLocation(location),
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      inviteId: this.props.invite?.id,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      redirectTo: this.props.redirectTo,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      listing: this.props.savedListing,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      subscribeSubsiteId: this.props.subscribedSubsite,
    };
    signUp(signupInfo)
      .then((userEnvironment) => {
        trackSignUp(userEnvironment.user, 'Email Password');
        configureTrackJs(userEnvironment.user.id);
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.updateUserEnvironment(userEnvironment);

        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        if (this.props.savedListing) {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          const { type, name } = this.props.savedListing;

          if (type === 'ORG') {
            pushFlashMessage({ type: 'SAVE_ORG', data: { orgName: name } });
          }
        }

        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        if (this.props.onSignup) {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          this.props.onSignup(userEnvironment.user);
        }
      })
      .catch((error) => {
        resetRecaptcha();
        handleError(error, {
          recaptchaKey: recaptchaKey + 1,
          gRecaptchaResponse: undefined,
        });
      });
  };

  render() {
    const { analyticsTitle, usageContext, invite } = this.props;

    return (
      <SignupForm
        analyticsTitle={analyticsTitle}
        usageContext={usageContext}
        initialValues={this.initialValues}
        invite={invite}
        showLoginModal={this.showLoginModal}
        // @ts-expect-error TS(2322): Type '(email: string) => { to: string; state: { re... Remove this comment to see the full error message
        getLoginUrlAndState={this.getLoginUrlAndState}
        getThirdPartyLoginUrl={this.getThirdPartyLoginUrl}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const connector = connect(
  ({ userLocation }: MainStoreState) => {
    const props = {};

    if (userLocation.isLoaded) {
      // @ts-expect-error TS(2339): Property 'userLocation' does not exist on type '{}... Remove this comment to see the full error message
      props.userLocation = userLocation;
    }

    return props;
  },
  {
    updateUserEnvironment,
    fetchUserLocation,
  },
);

type PropsFromRedux = ConnectedProps<typeof connector> & {
  userLocation?: ApiUserLocation | null;
};

export const SignupFormContainer = connector(UnconnectedSignupFormContainer);
